import "normalize.css"
import "./src/styles/global.css"
